// extracted by mini-css-extract-plugin
export default {"shoeWeights":"pdp-shoeWeights","shoeWeight":"pdp-shoeWeight","sw_property":"pdp-sw_property"};